import React from 'react'
import numeral from 'numeral'
import { FormattedMessage } from 'react-intl'

import {
  coursesByCategory,
  coursesByType,
  sumOfCourseTraineesByCategory,
  sumOfCourseTraineesByType,
} from '../data/VocationalTraineesFrom17and18'

const VocationalTraineeesTables = ({ langKey, className }) => {
  return (
    <div className={`${className}`}>
      <table className="mb-8">
        <colgroup>
          <col style={{ width: '60%', minWidth: '60%' }}></col>
          <col style={{ width: '40%', minWidth: '40%' }}></col>
        </colgroup>
        <thead>
          <tr>
            <th colSpan="2"><FormattedMessage id="Vocational Trainees - Academic Year 2017/18 (by course categories)" /></th>
          </tr>
          <tr>
            <th><FormattedMessage id="Course Categories" /></th>
            <th><FormattedMessage id="Trainees" /></th>
          </tr>
        </thead>

        <tbody>
          {
            coursesByCategory.map((course, i) => (
              <tr key={i}>
                <td>{ course.category[langKey] }</td>
                <td className="text-right">{ numeral(course.count).format('0,0') }</td>
              </tr>
            ))
          }
          <tr className="table-footer">
            <td><FormattedMessage id="Total" /></td>
            <td className="number">{ numeral(sumOfCourseTraineesByCategory).format('0,0') }</td>
          </tr>
        </tbody>
      </table>

      <table className="mb-8">
        <colgroup>
          <col style={{ width: '60%', minWidth: '60%' }}></col>
          <col style={{ width: '40%', minWidth: '40%' }}></col>
        </colgroup>
        <thead>
          <tr>
            <th colSpan="2"><FormattedMessage id="Vocational Trainees - Academic Year 2017/18 (by course types)" /></th>
          </tr>
          <tr>
            <th><FormattedMessage id="Course Types" /></th>
            <th><FormattedMessage id="Trainees" /></th>
          </tr>
        </thead>

        <tbody>
          {
            coursesByType.map((course, i) => (
              <tr key={i}>
                <td>{ course.type[langKey] }</td>
                <td className="text-right">{ numeral(course.count).format('0,0') }</td>
              </tr>
            ))
          }
          <tr className="table-footer">
            <td><FormattedMessage id="Total" /></td>
            <td className="number">{ numeral(sumOfCourseTraineesByType).format('0,0') }</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

VocationalTraineeesTables.defaultProps = {
  className: '',
}

export default VocationalTraineeesTables
